<template>

  <div id="app">

    <div v-if="uploadInProgress" style="width: 100%; height: 100%; position: fixed; background: rgba(0,0,0,0.8); z-index: 10000; color: #fff; text-align: center; font-size: 300%; padding-top: 15%">
      <div class="spinner-border text-light" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <div class="lead font-weight-bold">Bitte warten</div>
      <p class="lead font-weight-light">Datei(en) werden hochgeladen</p>
    </div>

        <div class="col-12 bg-header">
          <div class="container">
            <div class="row">
              <div class="col-12 col-md-2 text-center">
                <a href="https://www.rueden.de/"><img src="https://www.rueden.de/images/Logo-Horizontal-inversion.png" alt="VON RUEDEN"/></a>
              </div>
              <div class="col-12 col-md-8 text-center">
                <h1>Beitragsanpassung Private Krankenversicherung</h1>
              </div>
            </div>
          </div>
        </div>

        <div class="container pt-5 pb-5 mb-5" v-if="schritt === 1">

          <form id="form_1">

            <Schrittanzeige :schritt="schritt" datenvervollstaendigung="true" />

            <div class="row">
              <div class="col-12 col-lg-8 offset-lg-2">
                <div class="formular-box">

                  <div class="row">
                    <div class="col-12">
                      <h2 class="mt-0 pt-0 mb-4">1. Informationen</h2>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-lg-12">
                      <h5>Meine Anschrift</h5>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-12"
                         :class="{'col-md-9' : this.address_missingNo }">
                      <div class="rueden-input">
                        <label v-bind:class="{ 'text-danger' : address_empty }">Straße, Postleitzahl, Ort</label>

                        <vue-google-autocomplete
                            id="address_google"
                            ref="addressGoogle"
                            classname="form-control"
                            placeholder=""
                            types="address"
                            v-on:placechanged="getAddressData"
                            v-on:blur="blurGetAddressData"
                            :country="['de','ch','at']"
                            v-model="address_google"
                        >
                        </vue-google-autocomplete>
                        <input class="form-control d-none" type="text" v-model="strasse" name="strasse" required/>
                        <small style="line-height: 1; color: rgb(134, 134, 134)" v-bind:class="{ 'text-danger' : address_empty }"> Wählen Sie bitte eine der Adressen aus.</small>
                        <!--<small style="line-height: 1" class="text-danger" v-if="address_missingNo && !address_empty">Bitte geben Sie
                          eine Hausnummer an.</small>
                        -->
                      </div>
                    </div>

                    <div class="row d-none">
                      <div class="col-4">
                        <div class="rueden-input">
                          <label>PLZ</label>
                          <input ref="address_plz" class="form-control" type="text" v-model="plz"
                                 name="plz" required/>
                        </div>
                      </div>
                      <div class="col-4">
                        <div class="rueden-input">
                          <label>Ort</label>
                          <input class="form-control" type="text" v-model="ort" name="ort" required/>
                        </div>
                      </div>
                      <div class="col-4">
                        <div class="rueden-input">
                          <label>Land</label>
                          <input ref="land" class="form-control" type="text" v-model="land"
                                 name="land" required/>
                        </div>
                      </div>
                    </div>

                    <div v-if="address_missingNo" class="col-12 col-md-3">
                      <div class="rueden-input">
                        <label>Nr.</label>
                        <input ref="streetNumber" @change="setStreetNumber();" class="form-control" type="text" v-model="strasse_nummer" name="strasse_nummer" required/>
                      </div>
                    </div>
                  </div>

                  <div class="row">

                  </div>

                  <div class="row">
                    <div class="col-12">
                      <h5 class="mt-0 pt-0 mb-4">Krankenversicherung</h5>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-12">
                      <div class="rueden-input">
                        <label>Versicherungsnummer Krankenversicherung</label>
                          <input
                              class="form-control"
                              v-model="pkv_nummer"
                              type="text"
                              required
                              name="pkv_name"
                              autocomplete="off"
                          />
                      </div>
                    </div>
                    <div class="col-lg-4">
                      <div class="rueden-input">
                      <label>Beitragshöhe in Euro</label>
                        <div class="input-group">
                          <input
                              class="form-control"
                              v-model="pkv_beitragshoehe"
                              type="text"
                              required
                              name="pkv_beitragshoehe"
                              autocomplete="off"
                          />
                          <div class="input-group-append">
                            <div class="input-group-text">
                            <i  class="fa fa-eur"></i>
                            </div>
                          </div>
                        </div>
                    </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-12">
                      <h5 class="mt-0 pt-0 mb-4">Rechtsschutzversicherung</h5>
                    </div>
                  </div>

                  <div>

                      <div>
                        <div class="row">
                          <div class="col-12">
                            <div class="rueden-input">
                              <label>Name Ihrer Rechtsschutzversicherung</label>
                              <vue-simple-suggest @select="updateRSV($event);"
                                                  :list="rsv_synonyme"
                                                  :min-length="1"
                                                  :max-suggestions="0"
                                                  :filter-by-query="true">
                                <input
                                    class="form-control"
                                    name="rsv_1"
                                    v-model="rsv_name"
                                    type="text"
                                    required
                                />
                              </vue-simple-suggest>
                            </div>
                          </div>
                          <div class="col-12">
                            <div class="rueden-input">
                              <label>Versicherungsnummer Rechtsschutzversicherung</label>
                                <input
                                       class="form-control"
                                       name="rsv_1"
                                       v-model="rsv_nummer"
                                       type="text"
                                       required
                                />
                            </div>
                          </div>
                        </div>

                      </div>

                  </div>

                  <div class="row">
                    <div class="col-12 mt-4">
                      <button name="to-step-2" type="submit" @click.prevent="nextStep();" class="btn btn-primary-blue float-right">
                        weiter &nbsp; <i class="fa fa-angle-double-right" aria-hidden="true"></i>
                      </button>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </form>

        </div>

        <div class="container pt-5 pb-5 mb-5" v-if="schritt === 2">

          <form id="form_2">
            <Schrittanzeige :schritt="schritt" datenvervollstaendigung="true" />

            <div class="row">
              <div class="col-12 col-lg-8 offset-lg-2">
                <div class="formular-box">

                  <div class="row">
                    <div class="col-12">
                      <h2 class="mt-0 pt-0 mb-4">2. Unterlagen hochladen</h2>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-lg-12">

                      <div class="bg-light p-4 border border-1">
                        <button @click="openFileDialog('kv_versicherungsschein')" type="button" class="btn btn-sm btn-primary">
                          <i class="fa fa-upload"></i> Krankenversicherung: Versicherungsschein oder Versicherungsvertrag
                        </button>
                        <div class="files_kv_versicherungsschein">
                          <div v-for="(file, index) in files_finished_kv_versicherungsschein" :key="index">
                            <small><i class="fa fa-check-circle text-success"></i> {{ file.name }}</small>
                          </div>
                        </div>
                      </div>

                      <div class="bg-light p-4 border border-1 mt-2">
                        <button @click="openFileDialog('kv_erhoehungsschreiben')" type="button" class="btn btn-sm btn-primary">
                          <i class="fa fa-upload"></i> Erhöhungsschreiben seit 2012 – soweit vorhanden
                        </button>
                        <div class="files_kv_erhoehungsschreiben">
                          <div v-for="(file, index) in files_finished_kv_erhoehungsschreiben" :key="index">
                            <small><i class="fa fa-check-circle text-success"></i> {{ file.name }}</small>
                          </div>
                        </div>
                        <div class="form-checkboxes mt-3 mb-0">
                          <input type="checkbox" id="keine_weiteren_schreiben" required>
                          <label for="keine_weiteren_schreiben" class="pt-1">Weitere Schreiben liegen mir nicht vor</label>
                        </div>
                      </div>

                      <div class="bg-light p-4 border border-1 mt-2">
                        <button @click="openFileDialog('rsv_unterlagen')" type="button" class="btn btn-sm btn-primary">
                          <i class="fa fa-upload"></i> Unterlagen Rechtsschutzversicherung
                        </button>
                        <div class="files_rsv">
                          <div v-for="(file, index) in files_finished_rsv_unterlagen" :key="index">
                            <small><i class="fa fa-check-circle text-success"></i> {{ file.name }}</small>
                          </div>
                        </div>
                      </div>

                      <!-- File Input -->
                      <input @change="addFilesToList" class="d-none" type="file" id="files" name="files" multiple />

                    </div>
                  </div>

                  <div class="row">
                    <div class="col-6 mt-4">
                      <button name="back-to-step-1" class="btn btn-secondary" @click.prevent="stepBack();">
                        <i class="fa fa-angle-double-left" aria-hidden="true"></i> &nbsp; zurück
                      </button>
                    </div>
                      <div class="col-6 mt-4">
                        <button name="to-step-2" type="submit" @click.prevent="nextStep();" class="btn btn-primary-blue float-right">
                          weiter &nbsp; <i class="fa fa-angle-double-right" aria-hidden="true"></i>
                        </button>
                      </div>
                  </div>

                </div>
              </div>
            </div>

          </form>

        </div>

    <div class="container pt-5 pb-5 mb-5" v-if="schritt === 3">

      <form id="form_3">
        <Schrittanzeige :schritt="schritt" datenvervollstaendigung="true" />

        <div class="row">
          <div class="col-12 col-lg-8 offset-lg-2">
            <div class="formular-box">

              <div class="row">
                <div class="col-12">
                  <h2 class="mt-0 pt-0 mb-4">3. Aufklärung</h2>
                </div>
              </div>

              <div class="row">
                <div class="col-lg-12">

                  <h5>Ich bin darüber aufgeklärt:</h5>

                  <ul class="list-group">
                    <li class="list-group-item">
                      <div class="form-check">
                        <input type="checkbox" id="check_1" v-model="check_1" class="form-check-input" />
                        <label class="form-check-label" for="check_1">dass mir durch mein Vorgehen keine vertraglichen Nachteile seitens der Krankversicherung drohen (Leistungskürzung, Kündigung oder ähnliches).</label>
                      </div>
                    </li>
                    <li class="list-group-item">
                      <div class="form-check">
                        <input type="checkbox" id="check_2" v-model="check_2" class="form-check-input" />
                        <label class="form-check-label" for="check_2">die durchschnittliche Erstattungsanspruch ca. 5.450 EUR beträgt.</label>
                      </div>
                    </li>
                    <li class="list-group-item">
                      <div class="form-check">
                        <input type="checkbox" id="check_3" v-model="check_3" class="form-check-input" />
                        <label class="form-check-label" for="check_3">dass die Kanzlei VON RUEDEN eine kostenlose Deckungsanfrage bei meiner Rechtschutzversicherung stellt.</label>
                      </div>
                    </li>
                    <li class="list-group-item">
                      <div class="form-check">
                        <input type="checkbox" id="check_4" v-model="check_4" class="form-check-input" />
                        <label class="form-check-label" for="check_4">dass die Kanzlei VON RUEDEN mit der weiteren Fallbearbeitung beginnt, sobald eine Deckungszusage meiner Rechtsschutzversicherung vorliegt.</label>
                      </div>
                    </li>
                  </ul>

                </div>
              </div>

              <div class="row">
              <div class="col-12 col-sm-6 mt-4">
                <button name="back-to-step-1" class="btn btn-secondary" @click.prevent="stepBack();">
                  <i class="fa fa-angle-double-left" aria-hidden="true"></i> &nbsp; zurück
                </button>
              </div>
              <div class="col-12 col-sm-6 mt-4">
                <button
                    type="button"
                    :disabled="!check_1 || !check_2 || !check_3 || !check_4"
                    name="final-submit" class="btn btn-primary-blue float-right" @click="submitForm()">
                  Bestätigen &nbsp; <i class="fa fa-angle-double-right" aria-hidden="true"></i>
                </button>
              </div>
              </div>

            </div>
          </div>


        </div>

      </form>

    </div>

    <div class="container pt-5 pb-5 mb-5" v-if="schritt === 4">
          <Schrittanzeige :schritt="schritt" datenvervollstaendigung="true" />

          <div class="row mb-5">
            <div class="col-12 col-lg-8 offset-lg-2">
              <div class="formular-box">
                <div class="row">
                  <div class="col-12 text-center">
                    <div class="alert alert-info">
                      <h2 class="mt-0 pt-0 mb-0 pt-2 pb-4">Vielen Dank für die Übersendung Ihrer Unterlagen.</h2>
                      Sollten wir ergänzende Informationen von Ihnen benötigen, melden wir uns bei Ihnen. Ansonsten halten wir Sie über den Fortgang stets auf dem aktuellen Stand.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Footer -->
        <div class="col-12 mb-4">
          <div class="container">
            <div class="row">
              <div class="col-12 col-lg-8 offset-lg-2 text-center text-secondary">
                &copy; 2022 - VON RUEDEN Partnerschaft von Rechtsanwälten<br />
                <b-link v-b-modal.modal-widerrufsbelehrung>Widerrufsbelehrung</b-link> &middot; <a href="#" v-b-modal.modal-datenschutzerklaerung>Datenschutzerklärung</a>
              </div>
            </div>
          </div>
        </div>

        <!-- Modals -->
        <Datenschutzerklaerung/>
        <Widerrufsbelehrung/>

  </div>

</template>
<script>

import Schrittanzeige from '../../components/pkv/Schrittanzeige'
import VueSimpleSuggest from 'vue-simple-suggest'
import Datenschutzerklaerung from '../Datenschutzerklaerung'
import Widerrufsbelehrung from '../Widerrufsbelehrung'
import 'vue-simple-suggest/dist/styles.css' // Optional CSS
import VueGoogleAutocomplete from 'vue-google-autocomplete'
import axios from "axios";

export default {

  components: {Schrittanzeige, Datenschutzerklaerung, Widerrufsbelehrung, VueGoogleAutocomplete, VueSimpleSuggest},

  data() {
    return {

      // Schritt
      schritt: 1,

      // Formular
      anrede: null,
      vorname: null,
      nachname: null,

      pkv_name: null,
      pkv_nummer: null,
      pkv_beitragshoehe: null,

      kostenlos_anfragen: null,
      beratung_alternativen: null,
      email: null,
      land: null,
      strasse: null,
      strasse_nummer: null,
      plz: null,
      address_google: null,
      address_empty: false,
      address_missingNo: true,
      ort: null,

      has_rsv: null,
      show_more_rsv: false,
      rsv: [],
      rsv_name: null,
      rsv_nummer: null,

      check_1: null,
      check_2: null,
      check_3: null,
      check_4: null,

      files: [],
      file_tag: null,
      uploadInProgress: false,
      files_kv_versicherungsschein: [],
      files_kv_erhoehungsschreiben: [],
      files_rsv_unterlagen: [],
      files_finished_kv_versicherungsschein: [],
      files_finished_kv_erhoehungsschreiben: [],
      files_finished_rsv_unterlagen: [],

      zustimmung_datenschutz_und_widerruf: null,
      token: null
    }
  },
  mounted() {
    this.pkv_name = this.$route.query.pkv;
    document.title = 'Private Krankenversicherung - Datenvervollständigung';
    this.token = this.$route.query.token;
    if(!this.token) {
      window.location.href = "https://www.rueden.de";
    }
    this.getLead();
  },
  methods: {
    getLead() {
      let url = 'https://flow.rueden.de/api/get/lead/'+this.token;
      let _this = this;
      axios.get(url)
          .then((response) => {
            let lead = response.data;
            _this.nachname = lead.nachname;
          })
    },
    addFilesToList() {
      let _this = this;
      let selectedFiles = document.getElementById("files").files;
      Array.prototype.forEach.call(selectedFiles, function (file) {
        _this['files_'+_this.file_tag].push(file);
      });
      this.uploadFiles()
    },
    uploadFiles() {

      let _this = this;

      let tag = 'KV Versicherungsschein';
      if(this.file_tag === 'rsv_unterlagen') { tag = 'RSV Unterlagen'; }
      else if(this.file_tag === 'kv_erhoehungsschreiben') { tag = 'KV Erhöhungsschreiben'; }

      _this["files_"+_this.file_tag].forEach(function(item){

      _this.uploadInProgress = true;

        let formData = new FormData();
        formData.append('file', item);
        formData.append('tag', tag);
        formData.append('token', _this.token);

        axios.post('https://flow.rueden.de/api/import-files/pkv', formData, {headers: {'Content-Type': 'multipart/form-data'}})
            .then(() => {
              _this.uploadInProgress = false;
            })
            .then(() => {
              _this['files_finished_'+_this.file_tag].push(item);
              //_this["files_"+_this.file_tag].pop(); // Remove uploaded file from array
            })
            .catch(function () {
              _this.uploadInProgress = false;
            });

      })

    },
    openFileDialog(file_tag) {
      this.file_tag = file_tag;
      document.getElementById('files').click();
    },
    validateForm(id) {
      let form = document.getElementById("form_" + id);
      let isValid = form.checkValidity();
      if (!isValid) form.reportValidity();
      return isValid;
    },
    nextStep() {
      if (this.validateForm(this.schritt)) {
        this.schritt += 1;
      }
    },
    stepBack() {
      if (this.schritt > 1) this.schritt -= 1;
    },
    setStreetNumber() {
      if (this.strasse_nummer) {
        this.strasse = this.strasse + ' ' + this.strasse_nummer;
        this.setGoogleAddress();
        this.$refs.addressGoogle.$el.value = this.address_google;
        this.address_missingNo = false;
        if (!this.plz && this.strasse && this.ort && this.land) {
          var _this = this;
          var service = new window.google.maps.places.AutocompleteService();
          service.getPlacePredictions({ input: this.address_google, types: ['address'] }, function(predictions){
            var pID = predictions[0].place_id;
            var service2 = new window.google.maps.places.PlacesService(document.createElement('address_google'));
            service2.getDetails({fields:['address_components'], placeId:pID}, function(r) {
              r.address_components.forEach(function(c) {
                if (c.types.includes('postal_code')) {
                  _this.plz = c.long_name;
                  _this.setGoogleAddress();
                  _this.$refs.addressGoogle.$el.value = _this.address_google;
                }
              });
            });
          });
        }
      }
    },
    getAddressData: function (addressData) {
      this.address_empty = false;
      this.land = addressData.country;
      this.ort = addressData.locality;
      if (addressData.postal_code) this.plz = addressData.postal_code;
      if (addressData.street_number) {
        this.strasse_nummer = addressData.street_number;
        this.strasse = addressData.route  + ' ' + this.strasse_nummer;
        this.address_missingNo = false;
      } else {
        this.strasse_nummer = null;
        this.strasse = addressData.route;
        setTimeout(() => {
          this.$refs.streetNumber.focus();
        });
        this.address_missingNo = true;
      }
      this.setGoogleAddress();
      this.$refs.addressGoogle.$el.value = this.address_google;
      let devPrefix = "";
      if (process.env.VUE_APP_ENV !== "prod") devPrefix = "(TEST) ";
      //Google Analytics
      this.$gtag.event('change', {
        'event_category': devPrefix + "PkV Formular",
        'event_label': "google-address (text)"
      });
    },
    setGoogleAddress() {
      let prevAddress = this.strasse;
      if (this.ort) {
        if (this.plz) {
          prevAddress = prevAddress + ", " + this.plz + " " + this.ort;
        } else {
          prevAddress = prevAddress + ", " + this.ort;
        }
      }
      prevAddress = prevAddress + ", " + this.land;
      this.address_google = prevAddress;
    },
    blurGetAddressData() {
      if (
          !this.strasse
          || !this.ort
      ) {
        this.address_empty = true;
        this.$refs.addressGoogle.$el.value = "";
      } else {
        this.setGoogleAddress();
        this.$refs.addressGoogle.$el.value = this.address_google;
      }
    },
    clearAddressFields() {
      this.plz = null;
      this.strasse = null;
      this.ort = null;
      this.strasse_nummer = null;
      // this.address_missingNo = false; // rausnehmen
    },
    submitForm() {
      if (this.validateForm(this.schritt) && !this.address_empty /*&& !this.address_missingNo*/) {
        let formData = new FormData();
        for (const [key, value] of Object.entries(this.$data)) {
          formData.append(key, value);
        }
        axios.post("https://flow.rueden.de/api/datenvervollstaendigung/pkv",
            formData,
        )
        this.schritt += 1;
      }
    },
    pkv_synonyme() {
      return axios.get('https://flow.rueden.de/api/get/all-pkv')
          .then(response => {
            return response.data[0];
          });
    },
    rsv_synonyme() {
      return axios.get('https://flow.rueden.de/api/get/all-rsv')
          .then(response => {
            return response.data[0];
          });
    },
    updateRSV(rsv) {
      this.rsv_name = rsv;
    },
  }
}
</script>
